import { render } from "./StandaloneSKUAdd.vue?vue&type=template&id=54f999de&scoped=true"
import script from "./StandaloneSKUAdd.vue?vue&type=script&lang=js"
export * from "./StandaloneSKUAdd.vue?vue&type=script&lang=js"

import "./StandaloneSKUAdd.vue?vue&type=style&index=0&id=54f999de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hobbes\\Desktop\\abounddata-vue-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f999de"]])

export default __exports__